import type {
  IInitialAccountAccessFormValues,
  IInitialAccountAccessMfaSupportFormValues,
} from '@klv/organisms/form-account-access/types';

export const initialValues: IInitialAccountAccessFormValues = {
  requestType: 'accountAccess',
  blockerType: '',
  billingDisputeReason: '',
  name: '',
  accountName: '',
  email: '',
  websiteUrl: '',
  issueDescription: '',
  recipients: [''],
  'g-recaptcha-response': '',
  formSource: 'accountAccess',
  mfaSupportReason: '',
};

export const initialValuesMfa: IInitialAccountAccessMfaSupportFormValues = {
  companyTestUrl: '',
  orgMailingAddress: '',
  profileNames: '',
  lastLoginDate: '',
  campaignFlowName: '',
  otherEmails: '',
  recentInvoice: '',
};
